var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69871",
    "data-name": "Group 69871",
    transform: "translate(-944 -1976)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 64,
    height: 64,
    rx: 2,
    transform: "translate(944 1976)",
    fill: "rgba(251,139,35,0.1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50725",
    "data-name": "Group 50725",
    transform: "translate(0 -160)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path-2",
    "data-name": "Path",
    width: 40,
    height: 40,
    rx: 2,
    transform: "translate(956 2148)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69873",
    "data-name": "Group 69873",
    transform: "translate(21808 22236.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(-20851 -20088.074)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,38s15-7.2,15-18V7.4L19,2,4,7.4V20C4,30.8,19,38,19,38Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19.0022029876709 34.60058975219727 C 20.31254005432129 33.85834503173828 22.44014549255371 32.54231262207031 24.5704174041748 30.75288963317871 C 26.51569747924805 29.11885070800781 28.04996871948242 27.43556022644043 29.13060760498047 25.7497501373291 C 30.37104797363281 23.81467056274414 30.99999809265137 21.88018035888672 30.99999809265137 20 L 30.99999809265137 9.508477210998535 L 18.99999809265137 5.188477516174316 L 6.999998092651367 9.508477210998535 L 6.999998092651367 20 C 6.999998092651367 21.86408996582031 7.618268013000488 23.7818603515625 8.837648391723633 25.70002937316895 C 9.902478218078613 27.37509918212891 11.4163179397583 29.04888916015625 13.33709812164307 30.67490005493164 C 15.48366069793701 32.49205017089844 17.66622924804688 33.84271621704102 19.0022029876709 34.60058975219727 M 18.99999809265137 38 C 18.99999809265137 38 3.999998092651367 30.79999923706055 3.999998092651367 20 L 3.999998092651367 7.400000095367432 L 18.99999809265137 2 L 34 7.400000095367432 L 34 20 C 34 30.79999923706055 18.99999809265137 38 18.99999809265137 38 Z",
    stroke: "none",
    fill: "#fb8b23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(-20841 -20076.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20614",
    "data-name": "Rectangle 20614",
    width: 12,
    height: 8.06,
    rx: 2,
    transform: "translate(3 5.215)",
    fill: "#fb8b23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58030",
    "data-name": "Path 58030",
    d: "M7,6.877V4.709a2.669,2.669,0,1,1,5.338,0V6.877",
    transform: "translate(-0.551 -0.725)",
    fill: "none",
    stroke: "#fb8b23",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature3.7b92a95547019807096be90a3f84ec27.svg";
export { ForwardRef as ReactComponent };